import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Header from "../Header";
import "./NoContent.scss";

const NoContent = ({ msg }) => {
  let navigate = useNavigate();

  return (
    <>
      <Header />
      <section className="landing-main-wrapper">
        <Container>
          <Row>
            <Col md={12}>
              <h1 className="page-title">
                Discover Extraordinary <span className="art-text">ARTs</span>
              </h1>
              <p className="art-middle-text">Buy your first NFT</p>
              <div className="box-main">
                <div className="image-block">
                  <span className="open-sea">
                    {" "}
                    <img src="/Component4.png" alt="surface" />
                  </span>
                  <span className="solana-art">
                    <img src="/Component2.png" alt="surface" />
                  </span>
                  {/* <img src="/Rectangle3-41.png" alt="surface" /> */}
                  <div className="wallet-icon-main">
                    <div className="wallet-icon">
                      <img src="/empty-wallet.svg" alt="surface" />
                    </div>
                    <h4>{msg}</h4>
                  </div>
                  <span className="axie">
                    <img src="/Component12.png" alt="surface" />
                  </span>
                </div>
                <div className="image-block second-image">
                  <span className="meta-mask">
                    <img src="/Component6.png" alt="surface" />
                  </span>
                  <span className="rarible">
                    <img src="/Component10.png" alt="surface" />
                  </span>
                  <img src="/Mask group1.png" alt="surface" />

                  <span className="Frame">
                    <img src="/Component8.png" alt="surface" />
                  </span>
                </div>
              </div>
            </Col>
            <Col md={12}>
              <div
                className="view-nft-btn"
                onClick={() => {
                  navigate(`/trending`);
                }}
              >
                View Trending ART{" "}
                <span>
                  <svg
                    width="19"
                    height="18"
                    viewBox="0 0 19 18"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      fill="#000"
                      d="M18.5 0.75C18.5 0.551088 18.421 0.360322 18.2803 0.21967C18.1397 0.0790178 17.9489 0 17.75 0H8.74997C8.55106 0 8.36029 0.0790178 8.21964 0.21967C8.07899 0.360322 7.99997 0.551088 7.99997 0.75C7.99997 0.948912 8.07899 1.13968 8.21964 1.28033C8.36029 1.42098 8.55106 1.5 8.74997 1.5H15.9395L0.718971 16.719C0.649239 16.7887 0.593925 16.8715 0.556186 16.9626C0.518447 17.0537 0.499023 17.1514 0.499023 17.25C0.499023 17.3486 0.518447 17.4463 0.556186 17.5374C0.593925 17.6285 0.649239 17.7113 0.718971 17.781C0.788703 17.8507 0.871487 17.906 0.962596 17.9438C1.0537 17.9815 1.15136 18.0009 1.24997 18.0009C1.34859 18.0009 1.44624 17.9815 1.53735 17.9438C1.62846 17.906 1.71124 17.8507 1.78097 17.781L17 2.5605V9.75C17 9.94891 17.079 10.1397 17.2196 10.2803C17.3603 10.421 17.5511 10.5 17.75 10.5C17.9489 10.5 18.1397 10.421 18.2803 10.2803C18.421 10.1397 18.5 9.94891 18.5 9.75V0.75Z"
                    />
                  </svg>
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default NoContent;
